export default {
    open: false,
    page: 0
};


// WEBPACK FOOTER //
// ./src/store/modules/info/state.js